<script setup>
import { Inertia } from "@inertiajs/inertia";
import { computed, ref } from "@vue/runtime-core";

const props = defineProps({
	href: {
		type: String,
	},
    color: {
        type: String,
    },
    status: {
        type: String,
    },
    type: {
        type: String,
        default: 'submit',
    },
    testid: {
        type: String,
    },
	variant: {
		type: String,
		default: 'solid',
		validator: (value) => {
			return ['solid', 'outline', 'link'].includes(value)
		}
	},
	icon: {
		type: Function,
	},
});

let hovered = ref(false)


const iconClass = computed(() => {
	if (props.variant === 'solid')  {
		return "fill-white"
	} else if (props.variant === 'outline' && hovered === false) {
		return `fill-${props.color}`
	} else if (props.variant === 'outline' && hovered === true) {
		return "fill-white"
	}
})

const sizeClasses = computed(() => {
	if (props.size === 'sm') {
		return "px-2 py-1 text-xs"
	} else if (props.size === 'md') {
		return "px-4 py-2 text-sm"
	} else if (props.size === 'lg') {
		return "px-4 py-2 text-base"
	}
})

const colorClasses = computed(function() {
    if(props.status == 'disabled') {
        return 'bg-gray-100 text-gray-500 cursor-not-allowed';
        // Disabled buttons should be used for disabled actions of any colour button.
    }

	//Green buttons

    if(props.color == 'green' && props.variant == 'solid') {
        return 'bg-Green hover:bg-Green-500 text-white';
        // Green buttons should be used for booking actions.
    }

	if(props.color == 'green' && props.variant == 'outline') {
		return 'bg-transparent hover:bg-Green-50 hover:text-Green-500 text-Green border border-Green ';
		// Green buttons should be used for booking actions.
	}

	if(props.color == 'green' && props.variant == 'link') {	
		return 'bg-transparent hover:text-Green-500 text-Green shadow-none';
		// Green buttons should be used for booking actions.
	}

	//Blue buttons

    if(props.color == 'blue' && props.variant == 'solid') {
        return 'bg-Blue hover:bg-Blue-700 text-white';
        // Blue buttons should be used for non-booking actions.
    }
	
	if(props.color == 'blue' && props.variant == 'outline') {	
		return 'bg-transparent hover:bg-Blue-50 hover:text-Blue-700   text-Blue border border-Blue';
	}

	if(props.color == 'blue' && props.variant == 'link') {
		return 'bg-transparent hover:text-Blue-700  text-Blue shadow-none';
	}

	//Yellow Buttons 

    if(props.color == 'yellow' && props.variant == 'solid') {
        return 'bg-Yellow-500 hover:bg-Yellow-600 text-white';
        // Yellow buttons should be used for ____ actions.
    }
	if(props.color == 'yellow' && props.variant == 'outline') {	
		return 'bg-transparent hover:text-Yellow-600 hover:bg-Yellow-50 text-Yellow border border-Yellow';
	}

	if(props.color == 'yellow' && props.variant == 'link') {
		return 'bg-transparent text-Yellow hover:text-Yellow-600 shadow-none';
	}

	//Orange Buttons

    if(props.color == 'orange' && props.variant == 'solid') {
        return 'bg-Orange hover:bg-Orange-700 text-white';
    }
	if(props.color == 'orange' && props.variant == 'outline') {	
		return 'bg-transparent hover:bg-Orange-50 hover:text-Orange-700  text-Orange border border-Orange';
	}
	if(props.color == 'orange' && props.variant == 'link') {
		return 'bg-transparent hover:text-Orange-700 text-Orange shadow-none';
	}
	
	//Red Buttons

    if(props.color == 'red' && props.variant == 'solid') {
        return 'bg-Red hover:bg-Red-700 text-white';
        // Red buttons should be used for cancel actions.
    }
	if(props.color == 'red' && props.variant == 'outline') {	
		return 'bg-transparent hover:bg-Red-50 hover:text-Red-700 text-Red border border-Red';
	}

	if(props.color == 'red' && props.variant == 'link') {
		return 'bg-transparent text-Red hover:text-Red-700 shadow-none';
	}

	// Light Grey Buttons

	if(props.color == 'light-grey' && props.variant == 'solid') {
		return 'bg-gray-200 hover:bg-gray-300 text-gray-700';
	}

	if(props.color == 'light-grey' && props.variant == 'outline') {
		return 'bg-transparent hover:bg-gray-100 hover:text-gray-700 text-gray-500 border border-gray-300';
	}

	if(props.color == 'light-grey' && props.variant == 'link') {
		return 'bg-transparent hover:text-gray-700 text-gray-500 shadow-none';
	}

    return 'bg-white text-gray-500';
    // White buttons should be used for all other actions.
    // This is the default button style.
});

const computedClasses = computed(() => {
    return colorClasses.value
})

function handleClick() {
	if(props.status == 'disabled') {
		return;
	}

	if(props.href) {
		Inertia.visit(props.href);
	}
}

</script>

<template>
    <button 
        :type="type"
		class="
			
			border border-transparent rounded-md 
			shadow-sm
			text-gray-700 
			py-2 px-4 
			flex items-center justify-center content-center
			text-sm font-medium  
			focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
        :class="computedClasses"
        :data-testid="testid"
		@mouseover="hovered = true"
		@mouseleave="hovered = false"
		@click="handleClick"
		:disabled="status === 'disabled'"
    >
     <component :is="icon" class="h-4 w-4 mr-2" :class="iconClass" /><slot></slot>
    </button>
</template>